import { Card, FullBox } from 'seagull';
import { useResponsive } from "../../../contexts";
import styles from "./OnboardingPage.module.scss";
import { Sidebar } from "./Sidebar/Sidebar";
import { StepsContainer } from "./Steps/StepsContainer/StepsContainer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OnboardingPage = _ref => {
  let {
    currentStep,
    direction,
    onStepClick,
    onBack,
    onNext,
    relationship,
    visitedSteps,
    statement,
    isStatementAccepted,
    onStatementChange,
    isNextDisabled,
    hideNextButton
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  if (isMobile) {
    return /*#__PURE__*/_jsx(StepsContainer, {
      currentStep: currentStep,
      direction: direction,
      onBack: onBack,
      onNext: onNext,
      relationship: relationship,
      isMobile: true,
      statement: statement,
      isStatementAccepted: isStatementAccepted,
      onStatementChange: onStatementChange,
      isNextDisabled: isNextDisabled,
      hideNextButton: hideNextButton
    });
  }
  return /*#__PURE__*/_jsx(Card, {
    className: styles.card,
    children: /*#__PURE__*/_jsxs(FullBox, {
      flexDirection: "row",
      className: styles.mainLayout,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.sidebar,
        children: /*#__PURE__*/_jsx(Sidebar, {
          currentStep: currentStep,
          onStepClick: onStepClick,
          relationship: relationship,
          visitedSteps: visitedSteps
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.steps,
        children: /*#__PURE__*/_jsx(StepsContainer, {
          currentStep: currentStep,
          direction: direction,
          onBack: onBack,
          onNext: onNext,
          relationship: relationship,
          statement: statement,
          isStatementAccepted: isStatementAccepted,
          onStatementChange: onStatementChange,
          isNextDisabled: isNextDisabled,
          hideNextButton: hideNextButton
        })
      })]
    })
  });
};